const ROUTES: Record<string, string> = Object.freeze({
  ROOT: "/",
  ABOUT: "/about",
  WORK: "/work",
  EDUCATION: "/education",
});

export default ROUTES;
